import { cn } from "@acme/utils";
import * as React from "react";

function EmptyState({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "bg-card flex flex-col items-center justify-center rounded-xl border px-6 py-12 text-center shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

function EmptyStateIcon({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="empty-state-icon"
      className={cn(
        "bg-accent/10 text-accent mb-4 flex size-14 items-center justify-center rounded-full [&>svg]:size-6",
        className,
      )}
      {...props}
    />
  );
}

function EmptyStateTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      data-slot="empty-state-title"
      className={cn(
        "font-display text-foreground text-base font-semibold",
        className,
      )}
      {...props}
    />
  );
}

function EmptyStateDescription({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      data-slot="empty-state-description"
      className={cn(
        "text-muted-foreground mt-1 max-w-[360px] text-sm text-balance",
        className,
      )}
      {...props}
    />
  );
}

function EmptyStateActions({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="empty-state-actions"
      className={cn(
        "mt-6 flex flex-wrap items-center justify-center gap-2",
        className,
      )}
      {...props}
    />
  );
}

export {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateTitle,
};
